/**
 * Created by intellicar-rinas on 23/3/18.
 */
import React, {Component} from 'react';
import './CarAnimation.scss';
import $ from 'jquery';
import logo from '../../assets/svg/logo.svg';
import nh100Logo from '../../assets/images/nh100-logo.png';
import fre8wiseLogo from '../../assets/images/fre8wise-logo.png';
import ioclLogo from '../../assets/images/iocl-logo.png';
import hpeLogo from '../../assets/images/hpe-logo.png';
import flyyLogo from '../../assets/images/flyy-logo.png';
import revvLogo from '../../assets/images/revv-logo.png';
// import redLogo from '../../assets/svg/red_2.svg';
import moeving from '../../assets/images/moeving.png';
import viryaLogo from '../../assets/images/virya.png';
import torklogo from '../../assets/images/torkLogo.png'
import greenDrive from '../../assets/images/greendrive_logo.svg'
import PerpetuityCapital_Logo from '../../assets/images/PerpetuityCapital_Logo.jpg';
import Biliti_black from '../../assets/images/Biliti_black.svg';
import mondayLogo from '../../assets/images/monday.svg'
import ketoLogo from '../../assets/images/keto_logo.png'
import gozapLogo from '../../assets/images/gozap.png'
import jupiterLogo from '../../assets/images/jupiterLogo.png'
import Red_1 from '../../assets/images/Red_1.png'
import cruzex from '../../assets/images/cruzex.png'
import easyv from '../../assets/images/easyv.png'




class CarAnimation extends Component {

    gridUnit = 50;
    height = window.innerHeight * (this.props.center ? 3 : 2);
    width = this.height;
    rows = parseInt(this.height / this.gridUnit);
    cols = parseInt(this.width / this.gridUnit);

    state = {
        formBusy: false,
        animationCars: (()=>{ let a = []; for(let i=0; i<80; i++) { a.push({id:i})} return a})(),
        rows: (()=>{ let a = []; for(let i=0; i<this.rows; i++) { a.push({id:i+1})} return a})(),
        cols: (()=>{ let a = []; for(let i=0; i<this.cols; i++) { a.push({id:i+1})} return a})(),
        loadingInfo:false,
        progress: {
            totalVehicles: 0,
            loadedVehicles: 0,
            progress: 0
        },
        loadedVehicles: 0
    };

    constructor(props){
        super(props);
        this.initAnimation = this.initAnimation.bind(this);
        this.processCar = this.processCar.bind(this);
        this.getHeadingVal = this.getHeadingVal.bind(this);
        this.turnAfter = this.turnAfter.bind(this);
        window.addVehicleLoadedProgressListener('loadingScreen', this.vehicleLoadedProgress)
    }

    vehicleLoadedProgress =progress=> {
        if(this.unmounted)
            return;
           
        let loadedVehicles = progress.loadedVehicles;
        let targetLoops = 12;
        let targetTime = 1000;
        let targetInterval = targetTime/targetLoops;
        let currentVehicles = this.targetLoadedVehicles || 0;
        let deltaVehicleCount = (loadedVehicles - currentVehicles) / targetLoops;
        clearInterval(this.loopInter);
        this.loopInter = setInterval(()=> {
            currentVehicles += deltaVehicleCount; 
            if(currentVehicles > loadedVehicles) {
                currentVehicles = loadedVehicles;
            }
            this.setState({loadedVehicles: Math.ceil(currentVehicles)});
            if(currentVehicles >= loadedVehicles) {
                clearInterval(this.loopInter);
            }
        }, targetInterval)
        this.setState({progress, loadedVehicles: currentVehicles});
        this.targetLoadedVehicles = loadedVehicles;
    }

    getHeadingVal(car, axis) {
        if(car.heading === 0) {
            return axis === 'x' ? 1 : 0;
        } else if(car.heading === 90) {
            return axis === 'y' ? -1 : 0;
        } else if(car.heading === 180) {
            return axis === 'x' ? -1 : 0;
        } else if(car.heading === 270) {
            return axis === 'y' ? 1 : 0;
        }
    }


    turnAfter(car){
        if(car.shouldTurnAfter)
            return;

        if(car.tempHeading) {
            let val;
            if(car.heading === 0 || car.heading === 180) {
                val = car.x;
            } else if(car.heading === 90 || car.heading === 270) {
                val = car.y;
            }
            if(val % this.gridUnit < 8) {
                car.heading = car.tempHeading;
                car.heading = car.heading < 0 ? car.heading * -1 : car.heading;
                car.heading = car.heading === 360 ? car.heading = 0 : car.heading;
                car.tempHeading = false;
                car.x += this.getHeadingVal(car, 'x') * val % this.gridUnit;
                car.y += this.getHeadingVal(car, 'y') * val % this.gridUnit;
            }
        } else {
            car.shouldTurnAfter = setTimeout(()=> {
                car.shouldTurnAfter = false;
                car.tempHeading = car.heading + (Math.random() > 0.5 ? 90 : -90) % 360;
            }, Math.random() * 3500)
        }
    }

    processCar(car) {
        if(!('el' in car)) {
            let w = Math.random() * this.width;
            let h = Math.random() * this.height;
            car.el = $(car.ref);
            car.x = w - (w % this.gridUnit);
            car.y =  h - (h % this.gridUnit);
            let randomSpeed = 2 + parseInt(Math.random() * 6);
            car.speed = randomSpeed - (randomSpeed % 2);
            car.heading = (Math.random() > 0.5 ? 90 : 0);
            let anim = Math.random() > 0.8 ? 'carRedAnimation' : 'carAnimation';
            car.el.css({animation: anim + ' ' + ( 700 + (Math.random() * 4500)) + 'ms infinite'})
        }

        car.x+=car.speed * this.getHeadingVal(car, 'x');
        car.y+=car.speed * this.getHeadingVal(car, 'y');

        this.turnAfter(car);

        if(car.x < 0) {
            car.heading = 0
        } else if(car.x > this.width) {
            car.heading = 180
        } else if(car.y < 0) {
            car.heading = 270
        } else if(car.y > this.height) {
            car.heading = 90
        }

        car.el.css({left:car.x - 4, top:car.y - 4, transform:'rotate('+car.heading+'deg)'});
    }

    initAnimation() {
        let container = this.refs.animationContainer;
        if(!container) {
            setTimeout(this.initAnimation, 1000);
            return;
        }

        $(container).css({height: this.height, width: this.width});

        clearTimeout(this.animationEngine);

        this.animationEngine = setInterval(()=> {
            this.state.animationCars.filter(car=>{return car.ref}).map(car=> {
                if(!car.processed) {
                    this.processCar(car);
                }
                return car;
            });
        }, 20);
    }


    componentDidMount() {
        this.initAnimation();
        setTimeout(()=>{
            this.setState({
                loadingInfo: true
            })
        },[20000])     
    };

    componentWillUnmount() {
        this.unmounted = true;
        if(window.vehicleLoadedProgressListeners['loadingScreen']) {
            delete window.vehicleLoadedProgressListeners['loadingScreen'];
        }
        clearInterval(this.loopInter);
    }

    getMotto =()=> {
        if(window.isWhiteLabelAvailable('nh100')) {
            return 'TRACK.SECURE';
        }
        if(window.isWhiteLabelAvailable('iocl')) {
            return 'CVTMS';
        }
        if(window.isWhiteLabelAvailable('hpe')) {
            return '';
        }
        if(window.isWhiteLabelAvailable('fly')) {
            return 'POWERED BY INTELLICAR';
        }
        if(window.isWhiteLabelAvailable('fre8wise')) {
            return ''
        }
        return '';
    }

    getLogo =()=> {
        if(window.isWhiteLabelAvailable('fre8wise')) {
            return <img src={fre8wiseLogo} className='fre8wiseLogo' alt=''/>;
        }
        if(window.isWhiteLabelAvailable('nh100')) {
            return <img src={nh100Logo} className='nh100Logo' alt=''/>;
        }
        if(window.isWhiteLabelAvailable('iocl')) {
            return <img src={ioclLogo} className='ioclLogo' alt=''/>;
        }
        if(window.isWhiteLabelAvailable('hpe')) {
            return <img src={hpeLogo} className='hpeLogo' alt=''/>;
        }
        if(window.isWhiteLabelAvailable('fly')) {
            return <img src={flyyLogo} className='flyyLogo' alt=''/>;
        }
        if(window.isWhiteLabelAvailable('revv')) {
            return <img src={revvLogo} className='flyyLogo' alt=''/>;
        }
        if(window.isWhiteLabelAvailable('moeving')) {
            return <img src={moeving} className='moevingLogo' alt=''/>;
        }
        if(window.isWhiteLabelAvailable('viryamobility')) {
            return <img src={viryaLogo} className='viryaLogo' alt=''/>;
        }
        if(window.isWhiteLabelAvailable('tork')) {
            return <img src={torklogo} className='torkLogo' alt=''/>;
        }
        if(window.isWhiteLabelAvailable('perpetuitycapital')) {
            return <img src={PerpetuityCapital_Logo} className='nh100Logo' alt=''/>;
        }
        if(window.isWhiteLabelAvailable('greendrivemobility')) {
            return <img src={greenDrive} className='intelliLogo' alt=''/>;
        }
        if(window.isWhiteLabelAvailable('bilitielectric')) {
            return <img src={Biliti_black} className='intelliLogo' alt=''/>;
        }
        if(window.isWhiteLabelAvailable('mondays')) {
            return <img src={mondayLogo} className='intelliLogo' alt=''/>;
        }
        if(window.isWhiteLabelAvailable('etomotors')) {
            return <img src={ketoLogo} className='ketoLogo' alt=''/>;
        }
        if(window.isWhiteLabelAvailable('gofuel')) {
            return <img src={gozapLogo} className='gozapLogo' alt=''/>;
        }
        if(window.isWhiteLabelAvailable('jupiterelectricmobility')) {
            return <img src={jupiterLogo} className='jupiterLogo' alt=''/>;
        }
         if(window.isWhiteLabelAvailable('libtracx')) {
            return <img src={cruzex} className='libtracxlogo' alt='cruzex'/>;
        }
        if(window.isWhiteLabelAvailable('easyv')) {
            return <img src={easyv} className='easyvlogo' alt='easyv'/>;
        }
        return  <img src={Red_1} className='intelliLogo' alt=''/>;
    }

    render() {
        return (
            <div className={"CarAnimation" + (this.props.center ? ' -center':'')}>
                <div className='ssoWidget'>
                    <div id="intellicarSSODropWidget"></div>
                </div>
                <div className="lf-backdrop">
                    {this.getLogo()}
                    <div className="lfb-desc">{this.getMotto()}</div>
                    {/* {this.props.center ? <div className="lfb-desc2">Loading</div> : ''}
                    {this.props.center ? <div className="lfb-spinner"></div> : ''} */}
                    {this.props.center ? (
                        <div className='lfbd-progress'>
                            {this.state.loadingInfo?(<div className='lfbdp-name'>
                                <div className='loading-cont'>LOADING</div>
                                {this.state.progress.totalVehicles?(
                                    <div className='loading-cont'></div>):(
                                        <div style={{color:'#9d5858'}} className='loading-cont'>This is taking a bit longer than usual. Please wait while the vehicle is loaded. </div>
                                )
                                }
                                <span className='loading-cont'>
                                         {this.state.progress.progress} %
                                </span>
                            </div>) : (<div className='lfbdp-name'>
                                <div className='loading-cont'>LOADING</div>
                                <span className='loading-cont'>
                                    {this.state.progress.progress} %
                                </span>
                            </div>) }

                            <div className='lfbdp-progress-bar'>
                                <div className='lfbdppb-item' style={{width: this.state.progress.progress+'%'}}></div>
                            </div>
                        </div>
                    ):''}
                    <div className="lfb-animation" ref="animationContainer">
                        <div className="lfb-animationContainer -lfba-1">
                            <div className="lfb-animationContainer -lfba-2">
                                <div className="lfb-animationContainer -lfba-3">
                                    {
                                        this.state.animationCars.map((car, index)=>{
                                            return (
                                                <div ref={ref=>car.ref = ref} key={index} className="lfba-car"></div>
                                            )
                                        })
                                    }
                                    {
                                        this.state.rows.map(i=>{
                                            return <div className="lfba-row" key={i.id} style={{top: i.id * this.gridUnit}}></div>
                                        })
                                    }
                                    {
                                        this.state.cols.map(i=>{
                                            return <div className="lfba-col" key={i.id}  style={{left: i.id * this.gridUnit}}></div>
                                        })
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

}

export default CarAnimation;